import Vue from 'vue';

export default Vue.component('grid', {
    props:{
        columns: Array,
        rows: Array,
        loadingRows: Boolean,
        resources: Object,
        queryParameters: Object,
        axe: Function
    }
});